import { render, staticRenderFns } from "./secVideo2.vue?vue&type=template&id=fb02192e&scoped=true&"
var script = {}
import style0 from "./secVideo2.vue?vue&type=style&index=0&id=fb02192e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb02192e",
  null
  
)

export default component.exports